import ApiService from "../../common/api.service";
import handleReject from "../../common/handleReject";

export default {
  methods: {
    /**
     * 获取公众号文章内容
     * @param url
     * @param mutation
     * @returns {Promise<unknown>}
     */
    getSalonInfo(url, mutation = null){
      return new Promise(((resolve, reject) => {
        ApiService.setHeader();
        ApiService.post('/manager/other/salon-info', {url})
        .then(response=>{
          mutation && this.$store.commit(mutation, null);
          resolve(response);
        })
        .catch(response=>{
          mutation && handleReject(this.$store, response, mutation);
          reject(response);
        })
      }))
    }
  }
}
